module.exports = __webpack_public_path__ + "img/bowen1.0810b9bd.png";